import { create } from "zustand";
import { axiosInstance } from "../lib/axios";

export interface TemplateQuestion {
  question: string;
  answerType: string;
  options: string[];
  required: boolean;
  section: string;
  placeholder?: string;
}
export interface QuestionnaireTemplate {
  _id: string;
  name: string;
  category: string;
  serviceType: string;
  description: string;
  order: number;
  active: boolean;
  isSystem: boolean;
  questions: TemplateQuestion[];
}

interface State {
  templates: QuestionnaireTemplate[];
  loading: boolean;
  fetchTemplates: () => Promise<void>;
}

export const useQuestionnaireTemplateStore = create<State>((set) => ({
  templates: [],
  loading: false,
  fetchTemplates: async () => {
    set({ loading: true });
    try {
      const { data } = await axiosInstance.get("/questionnaire-templates");
      set({ templates: data.templates || [] });
    } catch {
      /* silent */
    } finally {
      set({ loading: false });
    }
  },
}));
